<div class="container my-5 p-5 text-center bg-white rounded">
  <div class="d-flex justify-content-center align-items-center">
    <strong>Loading...</strong>
    <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
  </div>
</div>
